import { useEffect } from 'react';

export default function AdScript() {
  useEffect(() => {
    // Create script element for options
    const optionsScript = document.createElement('script');
    optionsScript.type = 'text/javascript';
    optionsScript.text = `
      atOptions = {
        'key' : 'c716e428e22d0e904327ab894f623f49',
        'format' : 'iframe',
        'height' : 250,
        'width' : 300,
        'params' : {}
      };
    `;
    document.body.appendChild(optionsScript);

    // Create script element for ad
    const adScript = document.createElement('script');
    adScript.type = 'text/javascript';
    adScript.src = '//www.highperformanceformat.com/c716e428e22d0e904327ab894f623f49/invoke.js';
    document.body.appendChild(adScript);

    return () => {
      // Cleanup on unmount
      document.body.removeChild(optionsScript);
      document.body.removeChild(adScript);
    };
  }, []);

  return <div className="ad-container fixed bottom-0 right-0 z-40" />;
}
